import { useEffect, useState } from "react";
import performanceIcon from "../../assets/images/performance.svg";
import { Link, useNavigate } from "react-router-dom";
import { LoadingSpinner } from "../general/loading-spinner";
import { getAthleteAcitivities } from "../../services/athlete";
import { Form } from "react-bootstrap";
import moment from 'moment';
import { t } from "i18next";
import statisticsWhiteIcon from "../../assets/images/statistics-white.svg";

interface AthleteActivitiesBlockProps {
    userId: string;
}

export function AthleteActivitiesBlock(props: AthleteActivitiesBlockProps) {
    const navigate = useNavigate();

    const [athleteActivities, setAthleteActivities] = useState<any[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [selecterdActivityId, setSelectedAvtivityId] = useState('');
    const [activitiesCount, setActivitiesCount] = useState(0);

    useEffect(() => {
        const userIds: string[] = [];
        userIds.push(props.userId);
        getAthleteAcitivities(userIds)
            .then((response: any) => {
                setAthleteActivities(response.data.activities);
                let newActivitiesCount = response.data.activities.filter((af: any) => af.metric == 'activities').length;
                setActivitiesCount(newActivitiesCount);
                setLoaded(true);
            });
    }, []);

    const handleActivityChange = (event: any) => {
        setSelectedAvtivityId(event.currentTarget.value);
    }

    return (
        <div className="block athlete-activities">
            <div className="block-inner">
                <h3 className="block-title">
                    <img src={ performanceIcon } alt={ t("Activities")} />
                    { t("Activities") }
                </h3>
                { !loaded && 
                    <LoadingSpinner />
                }
                <div className="block-content">
                    {loaded && athleteActivities.length > 0 &&
                        <div className="activites">
                            <Form.Select aria-label={ t("Activities") } name="activities" onChange={ handleActivityChange }>
                                <option value="">{ t("Activities") }</option>
                                { athleteActivities.filter((af: any) => af.metric == 'activities').map((a: any) => {
                                    if (a.durationInSeconds !== undefined) {
                                        const activityDate = new Date((a.startTimeInSeconds + a.startTimeOffsetInSeconds)*1000);
                                        const activityDateFormatted = moment(activityDate).format('Y-MM-DD')
                                        return <option key={ 'a-' + a.activityId } value={ a.activityId }>{ activityDateFormatted + ' - ' + a.activityName }</option>;
                                    }
                                })}
                            </Form.Select>
                            { selecterdActivityId == '' && activitiesCount > 0 &&
                                <div className="summary">
                                    <div className="heartrate activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').reduce((acc: number, e: any) => {return acc + e.averageHeartRateInBeatsPerMinute; }, 0)/activitiesCount).toFixed(2) } <span className="units">{ t("bpm") }</span>
                                        </div>
                                        <div className="label">
                                            { t("Heart Rate Avg") }
                                        </div>
                                    </div>
                                    <div className="cadence activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').reduce((acc: number, e: any) => {return acc + e.averageSpeedInMetersPerSecond; }, 0)/activitiesCount).toFixed(2) } <span className="units">{ t("m/s") }</span>
                                        </div>
                                        <div className="label">
                                            { t("Speed Avg") }
                                        </div>
                                    </div>
                                    <div className="duration activity-kpi">
                                        <div className="value">
                                            {  moment.utc((athleteActivities.filter((af: any) => af.metric == 'activities').reduce((acc: number, e: any) => {return acc + e.durationInSeconds; }, 0)/activitiesCount)*1000).format('HH:mm:ss') }
                                        </div>
                                        <div className="label">
                                            { t("Duration Avg") }
                                        </div>
                                    </div>
                                    <div className="calories activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').reduce((acc: number, e: any) => {return acc + e.activeKilocalories; }, 0)/activitiesCount).toFixed(2) } <span className="units">{ t("kcal") }</span>
                                        </div>
                                        <div className="label">
                                            { t("Active Calories Avg") }
                                        </div>
                                    </div>
                                </div>
                            }
                            { selecterdActivityId != '' && activitiesCount > 0 &&
                                <div className="summary">
                                    <div className="heartrate activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').filter((a: any) => a.activityId == selecterdActivityId).reduce((acc: number, e: any) => {return acc + e.averageHeartRateInBeatsPerMinute; }, 0)).toFixed(2) }
                                        </div>
                                        <div className="label">
                                            { t("Heart Rate") }
                                        </div>
                                    </div>
                                    <div className="cadence activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').filter((a: any) => a.activityId == selecterdActivityId).reduce((acc: number, e: any) => {return acc + e.averageSpeedInMetersPerSecond; }, 0)).toFixed(2) }
                                        </div>
                                        <div className="label">
                                            { t("Speed m/s") }
                                        </div>
                                    </div>
                                    <div className="duration activity-kpi">
                                        <div className="value">
                                            { moment.utc((athleteActivities.filter((af: any) => af.metric == 'activities').filter((a: any) => a.activityId == selecterdActivityId).reduce((acc: number, e: any) => {return acc + e.durationInSeconds; }, 0))*1000).format('HH:mm:ss') }
                                        </div>
                                        <div className="label">
                                            { t("Duration") }
                                        </div>
                                    </div>
                                    <div className="calories activity-kpi">
                                        <div className="value">
                                            { (athleteActivities.filter((af: any) => af.metric == 'activities').filter((a: any) => a.activityId == selecterdActivityId).reduce((acc: number, e: any) => { return acc + e.activeKilocalories; }, 0)).toFixed(2) }
                                        </div>
                                        <div className="label">
                                            { t("Active Calories") }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
                <div className="block-footer">
                    <Link to={ '/reports/athlete/' + props.userId + '/view'} title={ t("Reports") } className="btn btn-primary">
                        <img src={ statisticsWhiteIcon } alt={ t("Reports")} /> { t("Reports") }
                    </Link>
                </div>
            </div>
        </div>
    );
}  
